import type { ParsedLocation } from '@tanstack/react-router';

import { onlineManager } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import { t } from 'i18next';

export const warnIfOfflineNoCache = (
  location: ParsedLocation,
  cache: unknown[]
) => {
  // If all the required cache is exist, we don't need to show the warning
  if (cache.every((data) => data !== undefined)) {
    return;
  }

  const isOnline = onlineManager.isOnline();
  if (!isOnline) {
    throw redirect({
      mask: {
        to: '.',
      },
      search: {
        from: location.pathname,
        search: location.search,
      },
      to: '/offline',
    });
  }
};

export const handleOfflineOnMutate = () => {
  const isOnline = onlineManager.isOnline();
  if (!isOnline) throw Error(t('currentNoInternet', { ns: 'ui' }));
};
